import React, { useState } from "react";
import { Main } from './epidemic-components-lib';
import axios from "axios";

interface IItem {
  type: string;
  file: string;
  size: string;
}

function App({ messenger }: any) {
  const [isLoading, setIsLoading] = useState(false)

  const create = (data: IItem[]) => {
    messenger.create(data, (data: any): void => {
      // do nothing
    });
  };

  const componentCallback = async (data: any): Promise<void> => {
    try {
      setIsLoading(true);
      const request = await axios.post("https://plugin-voicecreator-api.ssemble.com/epidemic", {
        url: data.file || data.mp4,
      });
      const fileUrl = request.data.url;
      if (fileUrl) {
        const elements = [];
        elements.push({
          type: "audio",
          file: fileUrl,
          size: data.fileSize,
        });
        
        create(elements);
        setIsLoading(false)
      }
    }catch(error){
      console.info(error)
      setIsLoading(false)
    }
  };

  return (
      <Main getSongData={componentCallback} isLoading={isLoading} />
  );
}

export default App;
